import Settings from './Settings.vue';
import MenuItem from './MenuItem.vue';

const routes = [
  {
    name: 'modules.tax',
    component: Settings,
    path: '/modules/tax',
  },
];

export default {
  menu_item: MenuItem,
  settings_component: Settings,
  routes,
};
